import { useQuery } from '@change-corgi/core/react/async';
import type { QueryHookResult } from '@change-corgi/core/react/async';

// oxlint-disable-next-line @change/sibling-module-imports
import { fetchSearchTopicFacetValues } from 'src/app/pages/search/shared/utils/fetchSearchTopicFacetValues'; // eslint-disable-line @change/sibling-module-imports
import { useTypesenseConfig } from 'src/app/shared/hooks/typesense';

import { useInstantSearchIndexName } from '../useInstantSearchIndexName';

type Result = { readonly data: readonly string[] };

export function useSearchTopicFacetValues(): QueryHookResult<Result> {
	const { config } = useTypesenseConfig();
	const {
		data: { instantSearchIndexName, instantSearchPreset },
	} = useInstantSearchIndexName();

	return useQuery(
		async () => ({
			data: await fetchSearchTopicFacetValues({
				config,
				collectionName: instantSearchIndexName,
				instantSearchPreset,
			}),
		}),
		[config, instantSearchIndexName, instantSearchPreset],
		{ loadingBetweenQueries: false },
	);
}
